import { Services } from '@sigma-frontend-libs/commons'

import { buttonModes, icons, placements } from '@/utils'

import button from '@/components/button'
import dialog from '@/components/services/eventsHistory/dialog'

function renderDialog(h) {
  return h(
    dialog,
    {
      props: {
        entityId: this.entityId,
        value: this.showDialog
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    }
  )
}

export default function(h) {
  let label
  if (this.label) {
    label = this.getTranslate(`${Services.eventsHistory}.labels.eventsHistory`)
  }

  return h(
    button,
    {
      props: {
        icon: icons.manage_history,
        label,
        mode: buttonModes.flat,
        disabled: this.disabled
      },
      directives: [
        {
          name: 'g-tooltip',
          options: {
            value: this.getTranslate(`${Services.eventsHistory}.tooltips.historyButton`),
            placement: placements.top
          }
        }
      ],
      on: {
        click: () => {
          this.showDialog = true
        }
      },
      scopedSlots: {
        dialog: () => {
          return renderDialog.call(this, h)
        }
      }
    }
  )
}
